// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__f7I5z","rootSuccess":"CompleteLink_rootSuccess__22WGt","rootFailure":"CompleteLink_rootFailure__3OebV","isDisabled":"CompleteLink_isDisabled__1jS58"};